export const START_LOADING = 'START_LOADING';
export const STOP_LOADING = 'STOP_LOADING';
export const START_STREAM = 'START_STREAM';
export const STOP_STREAM = 'STOP_STREAM';
// src/app/reducers/auth.ts

type ActionType =
  | typeof START_LOADING
  | typeof STOP_LOADING
  | typeof START_STREAM
  | typeof STOP_STREAM;

type LoaderStateType = {
  loading: boolean;
  streaming: boolean;
};

const initialState: LoaderStateType = {
  loading: false,
  streaming: false,
};

const loaderReducer = (
  state = initialState,
  action: { type: ActionType },
): LoaderStateType => {
  switch (action.type) {
    case START_LOADING:
      return { ...state, loading: true };
    case STOP_LOADING:
      return { ...state, loading: false };
    case START_STREAM:
      return { ...state, streaming: true };
    case STOP_STREAM:
      return { ...state, streaming: false };
    default:
      return state;
  }
};

export default loaderReducer;
